<template>
  <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
    <div style="margin-top: 10px"></div>
    <div class="filter" v-if="type === '2'">
      <van-row gutter="10">
        <van-col span="10">
          <van-field
            class="col-self"
            v-model="serch.keyWord"
            placeholder="关键词"
          />
        </van-col>
        <van-col span="10">
          <van-field
            class="col-self"
            v-model="serch.date"
            placeholder="选择日期"
            readonly
            @focus="showDate = true"
          />
        </van-col>
        <van-col span="4">
          <div class="serch-btn" @click="onRefresh">搜索</div>
        </van-col>
      </van-row>
    </div>
    <van-list
      v-model:loading="loading"
      :finished="finished"
      :finished-text="datalist.length !== 0 ? '没有更多了' : ''"
      @load="getList"
    >
      <div v-for="item in datalist" :key="item.id">
        <div class="date">值班日期：{{ item.attendDate }}</div>
        <duty-row :item="item">
          <div class="right-but" v-if="type === '1'">
            <div class="on-duty">值班中…</div>
            <div class="add-message" @click.stop="addMsg(item)">
              <van-icon color="#0f5293" name="edit" /> 我要留言
            </div>
          </div>
          <div class="on-duty" v-if="type === '3'">未开始</div>
          <div class="on-duty" v-if="type === '2'" style="background: #7fa4c8">
            已结束
          </div>
        </duty-row>
      </div>
      <van-empty
        v-if="!datalist.length && !loading"
        description="暂无值班信息"
      />
    </van-list>
  </van-pull-refresh>
  <van-calendar
    color="#0f5293"
    :min-date="minDate"
    v-model:show="showDate"
    @confirm="onConfirm"
  />
  <van-skeleton title :row="3" v-if="!datalist.length && loading" />
</template>

<script>
import { onMounted, inject, ref, reactive, watch } from 'vue'
import { Empty, Icon, Button, Field, Col, Row, Calendar, PullRefresh, List, Skeleton } from 'vant'
import DutyRow from './dutyRow.vue'
import { useRouter } from 'vue-router'
// import { cancelToken } from '@/api/http'
import moment from 'moment'
export default {
  name: 'OnDutyToday',
  components: { DutyRow, [Empty.name]: Empty, [Icon.name]: Icon, [Button.name]: Button, [Field.name]: Field, [Col.name]: Col, [Row.name]: Row, [Calendar.name]: Calendar, [List.name]: List, [PullRefresh.name]: PullRefresh, [Skeleton.name]: Skeleton },
  props: {
    type: {
      type: String,
      default: '1'
    }
  },
  setup (props) {
    const datalist = ref([])
    watch(() => props.type, () => {
      page.pageNo = 1
      datalist.value = []
      serch.date = ''
      serch.keyWord = ''
      onRefresh()
      // cancelToken('取消请求')
    })
    const router = useRouter()
    const $api = inject('$api')
    onMounted(() => {
      // getList()
    })
    const getList = async () => {
      try {
        if (refreshing.value) {
          datalist.value = []
          refreshing.value = false
        }
        const res = await $api.livingRoom.officeonlinetopic.list({
          pageSize: page.pageSize,
          pageNo: page.pageNo,
          type: props.type,
          keyword: serch.keyWord,
          startTime: serch.date ? serch.date + ' 00:00:00' : '',
          endTime: serch.date ? serch.date + ' 23:59:59' : ''
        })
        page.pageNo++
        var { data, total } = res
        datalist.value = datalist.value.concat(data)
        page.total = total
        loading.value = false
        if (data.length !== page.pageSize) {
          finished.value = true
        }
      } catch (error) {
        finished.value = true
        loading.value = false
      }
    }
    const page = reactive({
      pageSize: 10,
      pageNo: 1,
      total: 0
    })
    const addMsg = ({ id, officeId }) => {
      router.push({ path: '/addMsg', query: { id, officeId } })
    }
    const serch = reactive({
      keyWord: '',
      date: ''
    })
    const showDate = ref(false)
    const onConfirm = (value) => {
      serch.date = moment(value).format('YYYY-MM-DD')
      console.log(serch.date)
      showDate.value = false
    }
    const loading = ref(false);
    const finished = ref(false);
    const refreshing = ref(false);
    const onRefresh = () => {
      page.pageNo = 1
      finished.value = false
      loading.value = true
      serch.date = ''
      serch.keyWord = ''
      getList()
    }
    return {
      datalist,
      page,
      addMsg,
      getList,
      serch,
      showDate,
      onConfirm,
      minDate: new Date(2010, 0, 1),
      loading,
      finished,
      onRefresh,
      refreshing
    }
  }
}
</script>
<style lang="less" scoped>
.on-duty {
  width: 90px;
  height: 36px;
  background: #0f5293;
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 17px;
  color: #ffffff;
  line-height: 36px;
  text-align: center;
  margin-bottom: 14px;
  cursor: pointer;
  margin-top: 10px;
}
.add-message {
  width: 90px;
  height: 36px;
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 17px;
  color: #0f5293;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #0f5293;
  cursor: pointer;
}

.date {
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 16px;
  padding-left: 14px;
  color: #121212;
  margin-bottom: 11px;
}
.scrollMenuBox {
  height: 800px;
}
.filter {
  margin-bottom: 24px;
  display: flex;
  padding: 0px 14px;
  .imput-box {
    margin-left: 20px;
    width: 400px;
  }
  .serch-btn {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 34px;
    background: #0f5293;
    border-radius: 2px;
    color: #ffffff;
    font-size: 14px;
    height: 100%;
  }
}
.col-self {
  border: 1px solid #e4e4e4;
  border-radius: 2px;
}
</style>